module.exports = "//public.getcloudapp.com/packs/media/images/annotate/tools-history-back-b2c79474644b2185183557f42027ea48.svg";